import {FormElement} from "./FormElement";
import {FormBuilder} from "../FormBuilder.js";
import {SchemaField} from "../../Infrastructure/Server/SchemaField";
const $ = jQuery;

export class CheckboxFormElement extends FormElement {

    checkboxLabel: string;
    checkboxValue: string;

    constructor(options: SchemaField, formBuilder: FormBuilder, external: {[key: string]: any}) {
        super(options, formBuilder, external);

        this.db_type = 'tinyint(1)';
        this.checkboxLabel = options.checkboxLabel;
        this.checkboxValue = options.checkboxValue;
    }

    setDomElements() {
        super.setDomElements();
        this.inputs.checkbox = $(this.domElements.main).find('input')[0];
    }

    setEventHandlers() {
        super.setEventHandlers();
        $(this.inputs.checkbox).on('change', (e)=>{
            //@ts-ignore
            this.value = e.target.checked;
            this.events.trigger('changed', this, [this]);
        });
    }


    getSchema(): { [p: string]: any } {
        let schema = super.getSchema();
        if (this.checkboxLabel) {
            schema.checkboxLabel = this.checkboxLabel;
        }
        if (this.checkboxValue) {
            schema.checkboxValue = this.checkboxValue;
        }
        return schema;
    }
}